export enum EConsentMode {
  GRANTED = 'granted',
  DENIED = 'denied'
}

export enum EPersonIncludeType {
  Access,
  Addresses,
  TargetComments,
  Integration,
  Phones,
  Preference,
  Responsible,
  Tax,
  EventConsolidated,
  FinancialConsolidated,
  HealthConsolidated,
  HistoryConsolidated,
  PhoneConsolidated,
  SubscriptionConsolidated,
  TechInfoConsolidated,
  UserConsolidated,
  StorageConsolidated,
}

export enum EAddressType {
  Others = 0,
  Home = 1,
  Business = 2,
}